import { AuthMiddleware } from "Infrastructure/Authentication/Middleware/AuthenticationMiddleware";
import { getSupertokensInit } from "Infrastructure/Authentication/Utils/getSupertokensInit";
import { getRoutes } from "Infrastructure/Routes/Router";
import { queryClientConfig } from "Infrastructure/State/queryClientConfig";
import { setupTheme } from "Infrastructure/Theme";
import { getMarketFromPath } from "Market/Utilities/getMarketFromPath";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { HelmetProvider } from "react-helmet-async";
import * as reactRouterDom from "react-router-dom";
import { BrowserRouter, Routes } from "react-router-dom";
import SuperTokens from "supertokens-auth-react";
import { ThirdPartyPreBuiltUI } from "supertokens-auth-react/recipe/thirdparty/prebuiltui";
import { getSuperTokensRoutesForReactRouterDom } from "supertokens-auth-react/ui";
import { z } from "zod";
import { zodI18nMap } from "zod-i18n-map";

SuperTokens.init(getSupertokensInit());

export function App() {
	const theme = setupTheme();
	const routes = getRoutes();
	const superTokensRoutes = getSuperTokensRoutesForReactRouterDom(
		reactRouterDom,
		[ThirdPartyPreBuiltUI],
	);

	z.setErrorMap(zodI18nMap);
	const queryClient = new QueryClient(queryClientConfig);

	return (
		<BrowserRouter basename={`/${getMarketFromPath()}`}>
			<HelmetProvider>
				<AuthMiddleware>
					<QueryClientProvider client={queryClient}>
						<ThemeProvider theme={theme}>
							<CssBaseline />
							<Routes>
								{superTokensRoutes}
								{routes}
							</Routes>
						</ThemeProvider>
						<ReactQueryDevtools initialIsOpen={false} />
					</QueryClientProvider>
				</AuthMiddleware>
			</HelmetProvider>
		</BrowserRouter>
	);
}
